import { Component, Input, Output, EventEmitter } from '@angular/core';

// [appendTo]="'body'"
@Component({
  selector: 'app-sweet-select',
  templateUrl: './sweet-select.component.html',
  styleUrls: ['./sweet-select.component.css'],
})
export class SweetSelectComponent {
  @Input() options: { label: string; value: any }[] = [];
  @Input() selected: any[] = [];
  @Input() placeholder?: string;
  @Output() selectionChange = new EventEmitter<any[]>();

  onSelectionChange() {
    this.selectionChange.emit(this.selected);
  }
}
